import React, { FunctionComponent, useEffect } from 'react';

import Layout from '../../containers/Layout';
import Title from '../../components/Title';
import withDocument from '../../hocs/withDocument';
import SelectedCard from '../../components/SelectedCard';
import OrderDetails from '../../components/OrderDetails';
import AddressDelivery from '../../components/AddressDelivery';
import CardBox from '../../components/CardBox';
import OrderTotal from '../../components/OrderTotal';
import CancelAction from '../../components/CancelAction';
import { Order as IOrder } from '../../requests/caipirinha-api/interfaces/order.interface';
import { useOrder } from '../../hooks/order/useOrder';
import { useCheckoutGtm } from '../../hooks/gtm/checkout/useCheckoutGtm';
import ButtonContinue from './Helpers/button-continue';
import { addProductToGA } from '../../utils/react-ga.utils';
import IcOrder from '../../assets/icons/ic_order.svg';
import IcCard from '../../assets/icons/ic_card.svg';
import CreditCardPCJ from '../../components/CreditCardPCJ';
import { PaymentMethodType } from '../../constants/paymentMethodType.enum';

interface Props {
  order: IOrder;
}

export const Order: FunctionComponent<Props> = ({ order }) => {
  const { confirmLoading, generatePaymentForm } = useOrder();
  const { sendDataToGtm } = useCheckoutGtm();
  const { details: { payments, amount } } = order;

  useEffect(() => {
    const {
      details: { products, services },
    } = order;
    addProductToGA(products);
    addProductToGA(services);

    sendDataToGtm(order, { type: 'checkout', name: '/pagamento/resumo' });
  }, []);

  const simulatedPayment = payments[0].type === PaymentMethodType.CARD &&
    payments[0].simulated
    ? payments[0] : null;

  return (
    <Layout
      title="Resumo do pedido"
      loading={confirmLoading}
      overContent={
        <ButtonContinue
          order={order}
          generatePaymentForm={generatePaymentForm}
        />
      }
      dark
    >
      <Title data-cy='order-text' icon={IcOrder} small>
        Pedido
      </Title>

      <OrderDetails
        order={order}
        products={order.details.products}
        services={order.details.services}
        shipping={order.details.shipping}
        delivery={order.details.delivery}
        purposePurchase={order.details.purposePurchase}
      />

      <Title data-cy='payment-method-title' icon={IcCard} small>
        Meio de Pagamento
      </Title>

      {order.details.payments && !simulatedPayment && (
        <CardBox>
          <SelectedCard payments={order.details.payments} />
          <hr />
          <OrderTotal payments={order.details.payments} />
        </CardBox>
      )}

      { simulatedPayment && <CreditCardPCJ paymentCard={simulatedPayment} totalOrder={amount}/>}

      {order.details.delivery &&
        (!order.details.delivery.type ||
          order.details.delivery.type !== 'pickupstore') &&
        order.details.delivery.address && (
          <AddressDelivery
            address={order.details.delivery.address}
            warning={false}
          />
      )}

      <CancelAction order={order} />
    </Layout>
  );
};

export default withDocument(
  Order,
  'Para sua segurança, informe o seu {documentName} para prosseguir com o pagamento!',
);
